import { createSlice } from "@reduxjs/toolkit";
import { substationReducer } from "../extraReducers/substationReducer";

// 定义初始化数据
const initialState = {
    updateSubstationsConfig: {} as any,
    createSubstationsConfig: {} as any,
    substationModuleConfig: {} as any,
    getSubstationsConfig: {} as any
};

const substationSlice = createSlice({
    name: "roleManagement",
    initialState,
    reducers: {},
    extraReducers: substationReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default substationSlice.reducer;
